module.exports = __webpack_public_path__ + "static/img/fishing_default.931636ce.png";